<template>
  <div class="voucherslist">
    <div class="voucherslist__listing">
      <template v-if="!isEmpty && !isLoading">
        <adx-vouchers-list :items='items' />
        <!-- <adx-pagination
          v-if="items.length > 0"
          @change-page="changePage"
          :max-page="maxPage"
          :selected-page="currentPage"
        /> -->
      </template>
      <adx-empty-selection v-if="isEmpty && !isLoading" />
      <adx-loading v-if="isLoading" slot="loading" />
    </div>
  </div>
</template>

<script>
import ListVouchers from '@/views/Admin/Vouchers/VouchersList/ListItems'
// import Pagination from '@/components/Pagination'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
// import moment from 'moment'
// import _ from 'lodash'

export default {
  name: 'adx-admin-vouchers-list',
  components: {
    'adx-vouchers-list': ListVouchers,
    // 'adx-pagination': Pagination,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
  },
  props: {

  },
  data() {
    return {
      items: [],
      isLoading: false,
      isEmpty: false
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.getVouchers()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getVouchers() {
      (async () => {
        this.isLoading = true
        const { data } = await api.get(apiV2.adminVoucher, { needToken: true })
        data.map(item => {
          this.items.push({
            id: item.id,
            code: item.code,
            type: item.type_name,
            amount: item.nominal,
            redeemed: item.redeemed,
            active: item.is_active
          })
        })
        this.isLoading = false
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>